(function (window, document, $, wsp) {

    'use strict';

    var data = [];

    $(function () {
        var estimations = $('#estimated-value').data('estimations');
        var chartType = parseInt($('#chart-type').data('type'));

        $.each(estimations, function(index, element) {
            data.push({x: element.registration_date, y: element.avg});
        });

        var targetValue = parseInt($('.car-value').data('value'));
        $('#estimated-value').html('Ungefährer Restwert: ' + $('.car-value').text());

        if ($('#wsp-chart').length === 1) {
            if (chartType === 1) {
                wsp.charts.createResidualValueChart('wsp-chart', data, targetValue);
            } else {
                wsp.charts.createValuePredictionChart('wsp-chart', data, targetValue);
            }
        }
    });
})(window, document, jQuery, wsp);